<script>
import { mapState, mapActions } from 'vuex'
import modalConfirmar from './confirmar'
import modalConfirmaSenha from './confirmaSenha'
import modalReport from './report'
import modalMiddle from './middleware'

export default {
  components: {
    modalConfirmar,
    modalConfirmaSenha,
    modalReport,
    modalMiddle
  },
  data () {
    return {
      estado: false,
      width: '500'
    }
  },
  computed: {
    ...mapState({
      list: state => state.modal.list,
      modalConfirmar: state => state.modal.confirmar,
      toaster: state => state.modal.toaster
    })
  },
  methods: {
    ...mapActions({
      modalCloseAll: 'modal/closeAll',
      modalCancel: 'modal/cancel',
      modalSave: 'modal/save',
      modalAddRef: 'modal/addRef',
      okConfirmar: 'modal/okConfirmar',
      closeConfirmar: 'modal/closeConfirmar'
    })
  },
  watch: {
    list: {
      handler: function () {
        let ind = this.list.findIndex(e => e.ativa === true)
        if (ind !== -1) {
          this.estado = true
          this.width = this.list[ind].width
        } else {
          this.estado = false
        }
      },
      deep: true
    }
  }
}
</script>

<template>
  <div>
    <modal-confirmar />
    <modal-confirma-senha />
    <modal-report />
    <v-dialog v-model="estado" @input="v => v || modalCloseAll()" :width="width">
      <keep-alive>
        <div v-if="list.length > 0">
          <div v-for="modal in list" :key="modal.id" v-show="modal.ativa">
            <modal-middle
              :modal="modal"
              @cancel="(...params) => modalCancel({ modal, params })"
              @save="(...params) => modalSave({ modal, params })"
              @onRef="(ref) => modalAddRef({ modal, ref })" />
          </div>
        </div>
      </keep-alive>
    </v-dialog>
    <v-snackbar v-model="toaster.open" :right="true" :top="true" :color="toaster.color"> {{ toaster.message }} </v-snackbar>
  </div>
</template>
